//import React, { useState, useEffect } from 'react';
//import {useLocation } from 'react-router-dom';

import "../PaginaCustomer.css";

//import parse from 'html-react-parser';

//import { language } from '../WEBContent/Language';

/*import {
    set_language,

} from '../../../Utils';*/


//import * as Hosts from "../../../Hosts";

const SkipToContentLink = () => {

    return (
        <a className="skip-to-content visually-hidden-focusable" href={window.location.pathname + '#navbar'}>Skip to main content</a>
    )
};
export default SkipToContentLink;